import { useSelector } from 'react-redux';
import { selectMarketingAttributionModels } from '../../../../../reducers/global/marketingAttributionReducer';
import { AutomationDialogContent } from '../../../../Automations/AutomationDialogContent';
import useAutomationApiPerType from '../../../../Automations/useAutomationApiPerType';
import { AutomationFormVariant } from '../../../../../types/enums/AutomationFormVariant';
import { selectDefaultCreationEnvironment } from '../../../environments/environmentsReducer';
import { Stack } from '@mui/material';
import { marketingAttributionSortOptions } from '../../../../Automations/consts';

export const AttributionModelsTableWithFilters = () => {
  const marketingAttributionModels = useSelector(selectMarketingAttributionModels);
  const crmOrg = useSelector(selectDefaultCreationEnvironment);

  const { onSaveOrCreate, onDeleteAutomation, onDeployAutomation } = useAutomationApiPerType({
    automationVariant: AutomationFormVariant.MARKETING_ATTRIBUTIONS,
  });

  const viewInSalesforceLink = crmOrg?.instanceUrl
    ? `${crmOrg?.instanceUrl}/lightning/o/Dashboard/home?queryScope=userFolders`
    : undefined;

  return (
    <Stack sx={{ height: '100%', overflow: 'hidden', pb: 4 }}>
      <AutomationDialogContent
        automations={marketingAttributionModels ?? []}
        onDeleteAutomation={onDeleteAutomation}
        crmOrgId={crmOrg?.id ?? ''}
        onSaveOrCreate={onSaveOrCreate}
        sortOptions={marketingAttributionSortOptions}
        disableCanvasTemplates={true}
        onDeployAutomation={onDeployAutomation}
        filters={{}}
        viewInSalesforceLink={viewInSalesforceLink}
      />
    </Stack>
  );
};
